import React from "react";
import { CharacterSheet } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const Dominio: React.FC<Props> = ({ character, onChange }) => {
  const updateField = (field: keyof NonNullable<CharacterSheet["dominio"]>, value: any) => {
    if (!character.dominio) {
      character.dominio = {
        conceitoDao: "",
        custoAtivacao: 0,
        custoPorRodada: 0,
        raio: 0,
        efeitoEspecial: "",
      };
    }
    onChange({
      ...character,
      dominio: {
        ...character.dominio,
        [field]: value,
      },
    });
  };

  const toggleDominio = () => {
    if (character.dominio) {
      onChange({ ...character, dominio: undefined });
    } else {
      onChange({
        ...character,
        dominio: {
          conceitoDao: "",
          custoAtivacao: 0,
          custoPorRodada: 0,
          raio: 0,
          efeitoEspecial: "",
        },
      });
    }
  };

  if (!character.dominio) {
    return (
      <div className="section">
        <h2>Domínio</h2>
        <button type="button" onClick={toggleDominio} className="btn-add">
          + Adicionar Domínio
        </button>
      </div>
    );
  }

  return (
    <div className="section">
      <h2>Domínio</h2>
      <button type="button" onClick={toggleDominio} className="btn-remove">
        Remover Domínio
      </button>
      <div className="form-grid">
        <div className="form-group">
          <label>Conceito do Dao</label>
          <input
            type="text"
            value={character.dominio.conceitoDao}
            onChange={(e) => updateField("conceitoDao", e.target.value)}
            placeholder="Ex: Dao da Espada"
          />
        </div>
        <div className="form-group">
          <label>Custo de Ativação (PQ)</label>
          <input
            type="number"
            value={character.dominio.custoAtivacao}
            onChange={(e) => updateField("custoAtivacao", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Custo por Rodada (PQ)</label>
          <input
            type="number"
            value={character.dominio.custoPorRodada}
            onChange={(e) => updateField("custoPorRodada", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Raio (metros)</label>
          <input
            type="number"
            value={character.dominio.raio}
            onChange={(e) => updateField("raio", parseInt(e.target.value) || 0)}
            min="0"
          />
        </div>
        <div className="form-group" style={{ gridColumn: "1 / -1" }}>
          <label>Efeito Especial</label>
          <textarea
            value={character.dominio.efeitoEspecial}
            onChange={(e) => updateField("efeitoEspecial", e.target.value)}
            rows={3}
            placeholder="Descrição do efeito especial do domínio"
          />
        </div>
      </div>
    </div>
  );
};
